import { useCallback } from "react";
import { useCustomerAuth } from "@/contexts/CustomerAuthContext";

export function useAuthGate() {
  const { isAuthenticated, openLogin } = useCustomerAuth();

  const requireAuth = useCallback(
    (action: () => void) => {
      if (isAuthenticated) {
        action();
      } else {
        openLogin({ onComplete: action });
      }
    },
    [isAuthenticated, openLogin]
  );

  return { isAuthenticated, requireAuth };
}
